/* Blusafe Australia — Venix interactive manual data.
   Rendered by au-manual-engine.js (see sections/au-venix-interactive-manual.liquid).
   Guide content: September 2026 source manual. Illustrations: au-manual-venix-*.webp. */
window.VENIX_MANUAL_DATA = {
  "manual": {
    "title": "Venix Installation, Setup and Troubleshooting Manual",
    "product_family": "Venix",
    "manual_version": "V2026.1",
    "source_edition": "September 2026 source manual",
    "primary_app": "Tuya Smart",
    "install_time_estimate": "60–90 minutes",
    "lead": "Fit the bolt, panels and battery, set the unlocking direction, connect your Venix to 2.4 GHz Wi-Fi in the Tuya Smart app, add faces, palms and passcodes, manage members and fix the most common installation and recognition problems — without opening the PDF.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tuya.smart&hl=en_AU",
      "ios_app_store": "https://apps.apple.com/au/app/tuya-smart-life-smart-living/id1034649547"
    },
    "compatible_apps": {
      "Tuya Smart (recommended)": {
        "android": "https://play.google.com/store/apps/details?id=com.tuya.smart&hl=en_AU",
        "ios": "https://apps.apple.com/au/app/tuya-smart-life-smart-living/id1034649547"
      }
    },
    "critical_warnings": [
      "Check your door is 35–55 mm thick and has a 54 mm lockset hole (or use the 38 mm locator).",
      "Keep the door open while fitting, commissioning and testing.",
      "Set the unlocking direction while the lock is in its factory state — before adding any users.",
      "Your router must broadcast a 2.4 GHz network — Venix cannot join 5 GHz.",
      "Route the connection cable under the locator, never over it, and do not pinch it behind the panel."
    ]
  },
  "guides": [
    {
      "handle": "venix-01",
      "title": "What’s included",
      "category": "Preparation",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Verify that all components are present in the VENIX smart lock package before beginning installation.",
      "images": [
        {
          "src": "au-manual-venix-01-1.webp",
          "alt": "What’s included — What's Included"
        }
      ],
      "notes": [
        "Keep the packaging materials until installation is complete in case you need to return any items.",
        "Use the 38 mm locator only for a 38 mm door hole; a 54 mm locator is fitted as standard."
      ],
      "warnings": [
        "Do not proceed with installation if any components are missing. Contact your local installer or dealer immediately to obtain replacement parts."
      ],
      "tips": [],
      "steps": [
        "Open the product packaging carefully and remove all contents.",
        "Lay out all items on a clean, flat surface for easy identification.",
        "Check each item against the list below to confirm nothing is missing.",
        "If any item is missing or damaged, contact your local installer or dealer before proceeding."
      ],
      "expected_result": "All eight components are present and undamaged: 2 keys, strike box, strike plate, deadbolt, 38 mm locator, mounting plate, external panel unit, and internal panel unit.",
      "common_mistakes": [
        "Not checking for physical damage on components - Damaged parts may cause installation failure or security issues later.",
        "Losing the keys before testing mechanical operation - Keys serve as backup access; test them before enrolling digital credentials."
      ]
    },
    {
      "handle": "venix-02",
      "title": "Product dimensions and overview",
      "category": "Preparation",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Familiarise yourself with the VENIX smart lock dimensions and component layout before installation.",
      "images": [
        {
          "src": "au-manual-venix-02-1.webp",
          "alt": "Product dimensions and overview — Product Dimension"
        },
        {
          "src": "au-manual-venix-02-2.webp",
          "alt": "Product dimensions and overview — Product Overview"
        }
      ],
      "notes": [
        "Refer to the product diagrams for exact millimetre measurements of both the external and internal panel units."
      ],
      "warnings": [
        "Incorrect understanding of panel dimensions may lead to improper door preparation or misalignment during installation."
      ],
      "tips": [],
      "steps": [
        "Review the dimension diagrams for the External Panel Unit to understand its size and mounting requirements.",
        "Review the dimension diagrams for the Internal Panel Unit to understand its size and battery compartment location.",
        "Identify all key components on both panels, including keypad area, sensor locations, and connection points.",
        "Measure your door thickness to confirm it falls within the compatible range of 35–55 mm."
      ],
      "expected_result": "You can identify all major components on both panels and confirm your door dimensions are compatible with the VENIX lock.",
      "common_mistakes": [
        "Skipping dimension review before drilling - Leads to incorrectly sized holes that cannot accommodate the lock assembly.",
        "Confusing external and internal panel orientations - Results in reversed installation requiring complete disassembly.",
        "Not verifying door thickness compatibility - Doors outside the 35–55 mm range cannot properly secure the lock.",
        "Overlooking connection cable routing paths - Causes cable pinching or damage when panels are mounted."
      ]
    },
    {
      "handle": "venix-03",
      "title": "Factory reset",
      "category": "Reset",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Restore the VENIX smart lock to factory default settings, erasing all previously stored users and credentials.",
      "images": [
        {
          "src": "au-manual-venix-03-1.webp",
          "alt": "Factory reset — System Initialization (Factory Reset)"
        }
      ],
      "notes": [],
      "warnings": [
        "Factory reset permanently deletes all enrolled users, passwords, face recognition data, palmprint records, and custom settings. This action cannot be undone. Ensure you have administrative access to reconfigure the lock after reset."
      ],
      "tips": [],
      "steps": [
        "Remove the battery cover on the rear of the internal panel unit to expose the Reset key.",
        "Press and hold the Reset key for exactly 5 seconds until you hear 6 intermittent beeps.",
        "Wait for the voice prompt, then press the Unlock key on the front (external) panel to confirm the reset.",
        "Listen for the voice prompt \"Initialization Successful\" to confirm the factory reset is complete."
      ],
      "expected_result": "The lock emits a confirmation voice prompt \"Initialization Successful\" and all user data is erased, returning the device to its original factory state.",
      "common_mistakes": [
        "Releasing the Reset key before hearing 6 beeps - The reset process aborts and no changes are made to the lock.",
        "Forgetting to press the Unlock key after the voice prompt - The reset confirmation is not completed and settings remain unchanged.",
        "Attempting reset with users still enrolled without understanding data loss - All biometric and password data is permanently deleted without recovery option.",
        "Not verifying reset completion by checking for the success voice prompt - You may assume reset occurred when it actually failed, leading to configuration conflicts."
      ]
    },
    {
      "handle": "venix-04",
      "title": "Set the unlocking direction",
      "category": "Commissioning",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Configure the VENIX smart lock to detect and set the correct unlocking direction for your door orientation.",
      "images": [
        {
          "src": "au-manual-venix-04-1.webp",
          "alt": "Set the unlocking direction — Setting the Unlocking Direction"
        }
      ],
      "notes": [],
      "warnings": [
        "The unlocking direction can only be set when the lock is in factory default state with no users enrolled. If users are already registered, you must perform a factory reset first, which will erase all data. Plan this step before enrolling any members."
      ],
      "tips": [],
      "steps": [
        "Confirm the lock is in factory default state with no users enrolled (perform factory reset if needed).",
        "Insert the battery to power on the lock.",
        "Wait for the motor to automatically rotate and detect the unlocking direction.",
        "Listen for a long beep, which confirms the direction has been set successfully."
      ],
      "expected_result": "The motor completes its rotation cycle and emits a long beep, indicating the unlocking direction is correctly configured for your door.",
      "common_mistakes": [
        "Attempting to change direction after enrolling users - The lock prevents modification; you must reset and lose all user data to reconfigure.",
        "Not listening for the confirmation beep - You may assume direction is set when the motor failed to complete detection.",
        "Powering on the lock before ensuring factory default state - Existing user data blocks direction configuration.",
        "Ignoring door handing during initial installation planning - Results in having to reset and re-enrol all users later."
      ]
    },
    {
      "handle": "venix-05",
      "title": "Install the bolt and strike plate",
      "category": "Installation",
      "estimated_time": "30–45 minutes",
      "difficulty": "Hard",
      "summary": "Install the deadbolt and strike plate assembly into your door, including drilling new holes if your door is not pre-drilled.",
      "images": [
        {
          "src": "au-manual-venix-05-1.webp",
          "alt": "Install the bolt and strike plate — Drill Lockset and Bolt Holes"
        },
        {
          "src": "au-manual-venix-05-2.webp",
          "alt": "Install the bolt and strike plate — Install Bolt"
        },
        {
          "src": "au-manual-venix-05-3.webp",
          "alt": "Install the bolt and strike plate — Install Strike Plate"
        }
      ],
      "notes": [
        "Use the supplied drilling template. The dimensions here are not a scale drawing; 970 mm is a suggested height, not a fixed installation requirement."
      ],
      "warnings": [
        "Drilling errors can permanently damage your door. Measure twice before drilling. Wear safety goggles and ensure the door is securely supported during drilling. If your door already has pre-drilled holes matching VENIX specifications, skip section 5.1 and proceed directly to bolt installation."
      ],
      "tips": [],
      "steps": [
        "Verify your door thickness is between 35 mm and 55 mm using the template guide.",
        "Mark the hole centreline at 970 mm (38 3/16\") from the floor base using the provided template.",
        "Drill a 54 mm (2 1/8\") diameter hole through the door for the lockset.",
        "Fold the template along the door edge and mark a 25 mm (1\") diameter hole location for the bolt on the door edge.",
        "Drill the bolt hole and chisel a rectangular recess measuring 58 mm x 26 mm (2¼\" x 1\") with a depth of 3 mm (1/8\").",
        "Adjust the bolt length according to your door's backset measurement.",
        "Align the bolt hole with the drive bar centre and secure the bolt plate with screws.",
        "Extend the bolt fully, close the door gently against the door jamb, and mark the strike plate locations.",
        "Mark the centre line on the door jamb, place the strike plate, and scribe the outline.",
        "Chisel the strike plate recess to a depth of 2 mm (1/8\") and drill the bolt hole to a depth of 25 mm (1\").",
        "Insert the strike box and strike plate into the jamb recess and secure with screws."
      ],
      "expected_result": "The deadbolt extends and retracts smoothly, aligning perfectly with the strike plate hole when the door is closed.",
      "common_mistakes": [
        "Drilling without confirming door is not pre-drilled - Damages existing hardware and creates oversized, unusable holes.",
        "Incorrect centreline height measurement - Causes misalignment between bolt and strike plate, preventing proper locking.",
        "Drilling the lockset hole at wrong diameter (not 54 mm/2⅛\") - Panel units will not fit through the door opening.",
        "Not chiseling deep enough for bolt plate (minimum 3 mm/1/8\") - Bolt plate protrudes and prevents panel from sitting flush against door.",
        "Forgetting to extend bolt before marking strike plate position - Strike plate hole will not align with extended bolt, preventing door from latching."
      ]
    },
    {
      "handle": "venix-06",
      "title": "Replace the locator",
      "category": "Installation",
      "estimated_time": "5 minutes",
      "difficulty": "Medium",
      "summary": "Replace the pre-fitted 54 mm locator on the external panel with a 38 mm locator if your door hole requires it.",
      "images": [
        {
          "src": "au-manual-venix-06-1.webp",
          "alt": "Replace the locator — Pre-assemble External Panel (Locator Replacement)"
        }
      ],
      "notes": [
        "The external panel ships with a 54 mm locator already installed. Only perform this replacement if your door hole diameter is 38 mm. Always route the connection cable underneath the locator, never over it, to prevent cable damage."
      ],
      "warnings": [
        "Routing the cable over the locator instead of underneath can pinch or crush the cable when the locator is tightened, causing permanent connection failure."
      ],
      "tips": [],
      "steps": [
        "Loosen the two fixing screws on the external panel's locator.",
        "Remove the original 54 mm locator carefully, keeping the screws for reuse.",
        "Route the connection cable underneath the new 38 mm locator position.",
        "Fit the 38 mm locator into place and tighten securely with the two screws."
      ],
      "expected_result": "The 38 mm locator is firmly attached to the external panel with the connection cable properly routed underneath it.",
      "common_mistakes": [
        "Routing cable over the locator instead of underneath - Cable gets crushed when screws are tightened, breaking the electrical connection.",
        "Forgetting to check door hole size before replacing - Unnecessary replacement wastes time; keep the 54 mm locator if your door hole matches.",
        "Losing the original screws during removal - Replacement screws may not match thread specifications."
      ]
    },
    {
      "handle": "venix-07",
      "title": "Install the external panel",
      "category": "Installation",
      "estimated_time": "10 minutes",
      "difficulty": "Medium",
      "summary": "Mount the external panel unit to the door and connect it to the internal mounting plate.",
      "images": [
        {
          "src": "au-manual-venix-07-1.webp",
          "alt": "Install the external panel — Install External Panel"
        }
      ],
      "notes": [
        "Select the correct screw length based on your door thickness: use M4x30 mm screws for doors 35-45 mm thick, and M4x40 mm screws for doors thicker than 45 mm up to 55 mm. Install the tail bar vertically when the deadbolt is in the retracted position."
      ],
      "warnings": [
        "Using incorrect screw lengths can damage the door or fail to secure the panel properly. Ensure the connection cable is not pinched between the panel and door surface during installation."
      ],
      "tips": [],
      "steps": [
        "Pass the external handle connection cable through the door hole from the outside to the inside.",
        "Align the spindle of the external handle with the mortise mechanism inside the door.",
        "Place the external panel unit flush against the door surface.",
        "From inside the door, push the connector cable through the mounting plate opening.",
        "Fit the mounting plate onto the spindle, ensuring proper alignment.",
        "Select M4×30 mm screws for doors 35–45 mm thick, or M4×40 mm screws for doors over 45 mm up to 55 mm thick.",
        "Use two Screws D to temporarily fix the mounting plate in place."
      ],
      "expected_result": "The external panel is aligned with the door, the connection cable passes through to the interior, and the mounting plate is temporarily secured with the correct screws.",
      "common_mistakes": [
        "Using wrong screw length for door thickness - M4x30 mm screws are too short for thick doors (>45 mm); M4x40 mm screws may protrude on thin doors (<35 mm).",
        "Pinching connection cable between panel and door - Causes intermittent connection failures or permanent cable damage.",
        "Installing tail bar horizontally instead of vertically - Prevents proper engagement with internal panel mechanism."
      ]
    },
    {
      "handle": "venix-08",
      "title": "Install the internal panel and battery",
      "category": "Installation",
      "estimated_time": "10 minutes",
      "difficulty": "Medium",
      "summary": "Install the internal panel unit, connect it to the external panel, and insert the battery to power the VENIX smart lock.",
      "images": [
        {
          "src": "au-manual-venix-08-1.webp",
          "alt": "Install the internal panel and battery — Install Internal Panel & Connect the Battery"
        }
      ],
      "notes": [
        "Keep the door open after installation for commissioning and initial parameter settings. Do not close the door until you have verified all functions work correctly."
      ],
      "warnings": [
        "Ensure the lithium battery is inserted with correct polarity. Incorrect battery orientation can damage the lock's electronic components. Keep the door open during initial setup to avoid being locked out if configuration issues occur."
      ],
      "tips": [],
      "steps": [
        "Plug the external handle connector cable into the matching socket on the internal panel unit.",
        "Insert the tail bar into the inner panel knob mechanism.",
        "Attach the internal panel unit to the door, aligning it with the mounting plate and spindle.",
        "Tighten the internal panel screws using M5x10 mm-B screws and M3x4 mm-C screws securely.",
        "Open the battery compartment cover on the rear of the internal panel.",
        "Insert the lithium battery into the compartment, ensuring correct polarity alignment.",
        "Close the battery cover securely."
      ],
      "expected_result": "Both panels are firmly mounted, the connection cable is properly plugged in, the battery is installed, and the lock powers on successfully.",
      "common_mistakes": [
        "Not fully seating the connector cable plug - Causes intermittent connectivity between external and internal panels.",
        "Forgetting to insert tail bar into inner panel knob - Handle will not transmit motion to the locking mechanism.",
        "Closing the door immediately after installation - Prevents testing and commissioning; you may be locked out if setup fails.",
        "Not tightening all screws evenly - Panel may sit at an angle, causing misalignment and operational issues."
      ]
    },
    {
      "handle": "venix-09",
      "title": "Set up the app",
      "category": "App setup",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Download and set up the Tuya app to control and manage your VENIX smart lock remotely.",
      "images": [
        {
          "src": "au-manual-venix-09-1.webp",
          "alt": "Set up the app — Setup the App"
        }
      ],
      "notes": [
        "The Tuya app is required for all smart features including remote unlocking, user management, and network configuration. Ensure your smartphone has internet access during setup."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "Open the App Store (iOS) or Google Play Store (Android) on your smartphone.",
        "Search for \"Tuya\" in the store.",
        "Download and install the official Tuya app.",
        "Open the Tuya app and sign up for a new account, or log in if you already have one.",
        "Follow the in-app prompts to add your VENIX smart lock to your device list."
      ],
      "expected_result": "The Tuya app is installed on your smartphone, you have an active account, and the VENIX lock appears in your device list ready for network configuration.",
      "common_mistakes": [
        "Downloading unofficial or third-party apps - Only the official Tuya app supports VENIX lock integration; fake apps may compromise security.",
        "Skipping account registration - You cannot add devices or manage users without a registered Tuya account.",
        "Using an outdated app version - Older versions may lack compatibility with current VENIX firmware features."
      ],
      "app_links": true
    },
    {
      "handle": "venix-10",
      "title": "Connect to Wi-Fi",
      "category": "App setup",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Connect your VENIX smart lock to your home Wi-Fi network through the Tuya app for remote access and control.",
      "images": [
        {
          "src": "au-manual-venix-10-1.webp",
          "alt": "Connect to Wi-Fi — Network Setup (Add Lock over Wi-Fi)"
        }
      ],
      "notes": [],
      "warnings": [
        "The VENIX lock only supports 2.4 GHz Wi-Fi networks. It will not connect to 5 GHz networks. Ensure your router broadcasts a 2.4 GHz signal and that you have the correct password ready. If re-networking is needed after initial binding, you must unbind the device in the app, clear data, or restore factory defaults first."
      ],
      "tips": [],
      "steps": [
        "On the front (external) panel of the lock, press the \"3\" key and the \"🔓\" key simultaneously.",
        "Wait for the voice prompt and observe the indicator light blinking slowly, confirming pairing mode is active.",
        "Open the Tuya app on your smartphone and tap \"Add Device\".",
        "Select \"Venix\" from the device list.",
        "Select your 2.4 GHz Wi-Fi network from the available networks list.",
        "Enter your Wi-Fi password accurately and tap \"Next\".",
        "Wait for the app to complete the connection process with the door lock.",
        "When the app displays \"Device Added Successfully\", tap \"Done\" to finish setup."
      ],
      "expected_result": "The indicator light stops blinking, the app confirms \"Device Added Successfully\", and your VENIX lock appears as an online device in the Tuya app.",
      "common_mistakes": [
        "Attempting to connect to a 5 GHz Wi-Fi network - The lock hardware only supports 2.4 GHz; connection will fail indefinitely.",
        "Not pressing both keys (3 + 🔓) simultaneously - Pairing mode will not activate and the indicator will not blink.",
        "Entering incorrect Wi-Fi password - Connection fails silently; double-check password before submitting.",
        "Standing too far from the router during setup - Weak signal causes timeout; stay within 5 metres (16 feet) of the router."
      ]
    },
    {
      "handle": "venix-member-management",
      "title": "Member management",
      "category": "App management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Member management in the Tuya app.",
      "images": [],
      "notes": [
        "To revoke access, delete the member’s credentials before removing the member."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "On the lock homepage, tap “Member Management”.",
        "Select a member to manage their password, face and palmprint credentials."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 18
    },
    {
      "handle": "venix-11",
      "title": "Add or remove passwords",
      "category": "Access methods",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Add or remove numeric passwords for individual members through the Tuya app's Member Management interface.",
      "images": [
        {
          "src": "au-manual-venix-11-1.webp",
          "alt": "Add or remove passwords — Add a Password"
        },
        {
          "src": "au-manual-venix-11-2.webp",
          "alt": "Add or remove passwords — Remove a Password"
        }
      ],
      "notes": [
        "Turn on the \"Special Password\" toggle when creating a password if you want the lock to send a hijack alert notification. Special passwords allow covert emergency alerts while still unlocking the door."
      ],
      "warnings": [
        "Passwords are visible to anyone who observes entry. Choose passwords that are not easily guessable (avoid birthdays, sequential numbers like 123456, or repeated digits like 111111). Never share passwords via unsecured channels such as text messages or email."
      ],
      "tips": [],
      "steps": [
        "Open the Tuya app and navigate to your VENIX lock's homepage.",
        "Tap \"Member Management\" at the bottom of the screen.",
        "Select the designated member for whom you want to add or remove a password.",
        "To Add a Password: Tap \"+ Add\" beside the \"Password\" section.",
        "To Add a Password: Enter a numeric password between 6 and 10 digits in length.",
        "To Add a Password: Tap \"Save\" to confirm and store the password.",
        "To Remove a Password: Tap \"Delete Password\" in the member's credential list.",
        "To Remove a Password: Tap \"Confirm\" when prompted to permanently delete the password."
      ],
      "expected_result": "The new password is saved and immediately active for unlocking, or the deleted password is removed and no longer grants access.",
      "common_mistakes": [
        "Not enabling \"Special Password\" for emergency contacts - Regular passwords do not trigger hijack alerts; enable this feature for trusted individuals who may need to signal distress.",
        "Deleting a password without confirming - Accidental deletion locks out the member; verify before confirming removal.",
        "Not testing newly added password on the physical lock - App confirmation does not guarantee hardware synchronization; always test entry."
      ]
    },
    {
      "handle": "venix-12",
      "title": "Add or remove face recognition",
      "category": "Access methods",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Add or remove face recognition credentials for individual members through the Tuya app's Member Management interface.",
      "images": [
        {
          "src": "au-manual-venix-12-1.webp",
          "alt": "Add or remove face recognition — Add Face Recognition"
        },
        {
          "src": "au-manual-venix-12-2.webp",
          "alt": "Add or remove face recognition — Remove Face Recognition"
        }
      ],
      "notes": [
        "Face the camera directly and follow the on-screen prompts. The supplied PDF specifies 30–80 cm in normal indoor lighting."
      ],
      "warnings": [
        "Remove a person’s face credential when they should no longer have access."
      ],
      "tips": [],
      "steps": [
        "Open the Tuya app and navigate to your VENIX lock's homepage.",
        "Tap \"Member Management\" at the bottom of the screen.",
        "Select the designated member for whom you want to add or remove face recognition.",
        "To Add Face Recognition: Tap \"+ Add\" beside the \"Face recognition\" section.",
        "To Add Face Recognition: Tap \"Start to add\" to begin the enrolment process.",
        "To Add Face Recognition: Position yourself 30–80 cm from the lock's face camera in normal indoor lighting.",
        "To Add Face Recognition: Face the camera directly and follow the on-screen prompts to complete face enrolment.",
        "To Add Face Recognition: Tap \"Done\" when enrolment is successfully completed.",
        "To Remove Face Recognition: Tap \"Delete Face recognition\" in the member's credential list.",
        "To Remove Face Recognition: Tap \"Confirm\" when prompted to permanently delete the face data."
      ],
      "expected_result": "The face recognition credential is saved and the member can unlock the door by facing the camera, or the deleted face data is removed and no longer grants access.",
      "common_mistakes": [
        "Enrolling face in poor lighting conditions - Low light or harsh shadows reduce recognition accuracy; use normal indoor lighting.",
        "Not facing the camera directly during enrolment - Angled faces create incomplete templates that fail during actual use.",
        "Wearing accessories during enrolment that are not worn daily (sunglasses, hats, masks) - Recognition fails when accessories are removed; enrol with typical daily appearance."
      ]
    },
    {
      "handle": "venix-13",
      "title": "Add or remove palmprints",
      "category": "Access methods",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Learn how to enrol and remove palmprint biometric data for authorised members on your VENIX smart lock.",
      "images": [
        {
          "src": "au-manual-venix-13-1.webp",
          "alt": "Add or remove palmprints — Add Palmprint"
        },
        {
          "src": "au-manual-venix-13-2.webp",
          "alt": "Add or remove palmprints — Remove Palmprint"
        }
      ],
      "notes": [
        "Palm recognition requires placing the same palm repeatedly on the sensor area until enrolment completes successfully."
      ],
      "warnings": [
        "Ensure hands are clean and dry before enrolling palmprints. Moisture or dirt may reduce recognition accuracy."
      ],
      "tips": [],
      "steps": [
        "Enter the lock interface and tap \"Member Management\".",
        "Select the designated member from the member list.",
        "Tap \"+ Add\" beside the \"Palmprint\" option.",
        "Tap \"Start to add\" to begin the enrolment process.",
        "Place the same palm on the lock's palm-recognition area repeatedly until enrolment finishes, then tap \"Done\".",
        "To remove a palmprint, return to \"Member Management\", select the member, tap \"Delete palmprint\", and confirm deletion."
      ],
      "expected_result": "The palmprint is successfully enrolled or removed from the selected member's profile, and the lock recognises or no longer accepts the registered palm.",
      "common_mistakes": [
        "Using different palms during enrolment - causes failed recognition and requires re-enrolment",
        "Placing palm too quickly - results in incomplete biometric data capture",
        "Enrolling with wet or dirty hands - reduces recognition accuracy and may cause false rejections"
      ]
    },
    {
      "handle": "venix-14",
      "title": "Manage temporary passcodes",
      "category": "Access methods",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Create and manage temporary passcodes with various validity options for guests or short-term access on your VENIX smart lock.",
      "images": [
        {
          "src": "au-manual-venix-14-1.webp",
          "alt": "Manage temporary passcodes — Add a Temporary Passcode"
        },
        {
          "src": "au-manual-venix-14-2.webp",
          "alt": "Manage temporary passcodes — Remove a Temporary Passcode"
        }
      ],
      "notes": [
        "Temporary passcodes include Custom, Limited time, Single time, Dynamic, and Empty password types to suit different access scenarios."
      ],
      "warnings": [
        "Time-limited passwords require obtaining a clear code from the app and entering it on the lock before deletion. One-time and dynamic passwords cannot be manually deleted—they expire automatically."
      ],
      "tips": [],
      "steps": [
        "Enter the lock interface and tap \"Temporary Passcode\".",
        "Choose the password type: Custom, Limited time, Single time, Dynamic, or Empty.",
        "Enter a password name (optional), set the effective start time and invalid end time, then tap \"Get password\".",
        "To remove a temporary passcode, enter the Temporary Passcode interface, tap \"Record\", select the password to remove, and tap Delete."
      ],
      "expected_result": "A temporary passcode is generated with specified validity period, or an existing passcode is successfully removed from the system.",
      "common_mistakes": [
        "Attempting to delete one-time or dynamic passwords manually - these expire automatically and cannot be deleted",
        "Forgetting to obtain clear code from app before deleting time-limited passwords - deletion will fail without this step",
        "Not naming passwords clearly - makes it difficult to identify which code belongs to which guest"
      ]
    },
    {
      "handle": "venix-15",
      "title": "Doorbell and remote unlocking",
      "category": "Everyday use",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Enable doorbell-triggered remote unlocking and direct remote unlock functionality through the VENIX app with Wi-Fi connectivity.",
      "images": [
        {
          "src": "au-manual-venix-15-1.webp",
          "alt": "Doorbell and remote unlocking — Doorbell Unlocking"
        },
        {
          "src": "au-manual-venix-15-2.webp",
          "alt": "Doorbell and remote unlocking — Remote Unlock"
        }
      ],
      "notes": [
        "The lock must be paired with Wi-Fi before doorbell unlocking or remote unlock features can function properly."
      ],
      "warnings": [
        "Ensure stable Wi-Fi connection to avoid failed remote unlock attempts. Test the feature after initial setup to confirm functionality."
      ],
      "tips": [],
      "steps": [
        "Pair the lock with Wi-Fi through the lock interface settings.",
        "Press the doorbell key on the external panel—the paired phone receives a doorbell request notification.",
        "Tap the notification to view the scene outside the door, accept the call to talk with visitors, or tap Unlock to open the door remotely.",
        "For direct remote unlock, enter the lock homepage, press and hold the unlock icon until confirmed—the door opens immediately.",
        "Alternatively, tap \"Video surveillance\" on the lock homepage to view real-time outdoor footage and unlock remotely from the video interface."
      ],
      "expected_result": "A doorbell press sends a notification to the paired phone, and an authorised remote-unlock command operates the lock when it is connected.",
      "common_mistakes": [
        "Attempting remote unlock without Wi-Fi pairing - feature will not function without network connectivity",
        "Not testing remote unlock after setup - may discover connectivity issues only when urgently needed",
        "Holding unlock icon too briefly - incomplete press fails to trigger unlock confirmation"
      ]
    },
    {
      "handle": "venix-16",
      "title": "Permissions and Dormant switch",
      "category": "Settings",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Configure user permission levels and activate the Dormant switch to restrict lock functionality during designated sleep periods.",
      "images": [
        {
          "src": "au-manual-venix-16-1.webp",
          "alt": "Permissions and Dormant switch — Permission Settings & Dormant Switch"
        }
      ],
      "notes": [
        "Permission settings control which users can access lock features, while the Dormant switch disables most functions during sleep hours For example, real-time video surveillance and remote management.",
        "“Not available to all users” disables remote unlock; it does not describe every local unlocking method."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "Tap \"Set\" on the lock homepage to access settings.",
        "Tap \"Permission Settings\" and choose one of three options: Only administrators, Can be used by all users, or Not available to all users.",
        "Tap \"Confirm\" to apply the selected permission level.",
        "To enable the Dormant switch, navigate to settings and activate the Dormant switch option.",
        "Configure the sleep period start and end times according to household preferences."
      ],
      "expected_result": "Permission restrictions apply to specified user groups, and the sleep switch disables the use of video monitoring and remote management functions during the configured sleep period.",
      "common_mistakes": [
        "Forgetting to inform household members about Dormant switch activation - causes confusion when lock becomes unresponsive during sleep hours",
        "Configuring overly long dormant periods - may prevent legitimate late-night or early-morning access"
      ]
    },
    {
      "handle": "venix-17",
      "title": "Automatic lock and lock delay",
      "category": "Settings",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Set the automatic re-bolting delay after each unlock.",
      "images": [
        {
          "src": "au-manual-venix-17-1.webp",
          "alt": "Automatic lock and lock delay — Automatic Lock & Lock Delay"
        }
      ],
      "notes": [
        "The PDF states that the timer runs after each unlock. This is not confirmation that the door has closed."
      ],
      "warnings": [
        "Ensure the door closes completely before the auto-lock delay expires. Obstructions or improperly closed doors may prevent successful automatic locking."
      ],
      "tips": [],
      "steps": [
        "Enter the lock interface and tap \"Set\" to access settings.",
        "Turn on the \"Automatic lock switch\" to enable auto-lock functionality.",
        "Tap \"Auto lock delay time set\" and choose a delay duration (e.g., 5s, 10s, 15s, 30s).",
        "Tap \"Confirm\" to save the selected delay time.",
        "Test with the door open first: unlock and check that the bolt re-engages after the selected delay. Then check door and strike alignment before testing normal closed-door operation."
      ],
      "expected_result": "The bolt re-engages after the configured delay following each unlock. A secure door still requires the bolt to enter the aligned strike plate.",
      "common_mistakes": [
        "Setting delay time too short (e.g., 5s) - may not allow sufficient time to enter and close door properly",
        "Setting delay time too long (e.g., 60s+) - increases risk of forgetting to manually lock if auto-lock fails",
        "Not adjusting delay for household habits - families with children or pets may need longer delays for safe entry"
      ]
    },
    {
      "handle": "venix-volume",
      "title": "Lock navigation volume",
      "category": "Settings",
      "estimated_time": "1 minute",
      "difficulty": "Easy",
      "summary": "Lock navigation volume in the Tuya app.",
      "images": [],
      "notes": [],
      "warnings": [],
      "tips": [],
      "steps": [
        "On the lock homepage, tap “Set”.",
        "Tap “Lock navigation volume” and choose Mute, Low, Normal or High.",
        "Tap “Confirm”."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 35
    },
    {
      "handle": "venix-records",
      "title": "Alerts and records",
      "category": "Everyday use",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Alerts and records in the Tuya app.",
      "images": [],
      "notes": [
        "The PDF also describes an optional “Cloud storage service” in Set for doorbell videos and alarm snapshots. Review its terms in the app before enabling it."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "Open “Album / Log”, then “Log”.",
        "Choose “Alarm messages” to review event notifications.",
        "Choose “Door opening record” to review recorded unlock events and timestamps."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 36
    },
    {
      "handle": "venix-18",
      "title": "Unbind or remove the device",
      "category": "Reset",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Completely unbind and factory-reset your VENIX smart lock to remove all user data and disconnect it from the Tuya app for transfer or reconfiguration.",
      "images": [
        {
          "src": "au-manual-venix-18-1.webp",
          "alt": "Unbind or remove the device — Unbind   Remove Device"
        }
      ],
      "notes": [
        "Two unbind options exist—\"Unbind\" only disconnects the lock from the app while preserving all user data, whereas \"Unbind and wipe data\" performs a complete factory reset erasing all biometric data, passcodes, and member profiles."
      ],
      "warnings": [
        "Choosing \"Unbind and wipe data\" permanently deletes all enrolled faces, palmprints, passwords, and member information. This action cannot be undone. Ensure you have backed up any critical access credentials before proceeding."
      ],
      "tips": [],
      "steps": [
        "Enter the lock interface and tap the pencil icon in the top-right corner to access device management.",
        "Tap \"Remove Device\" to initiate the unbinding process.",
        "Select \"Unbind and wipe data\" to perform a complete factory reset, or choose \"Unbind\" to only disconnect from the app while preserving data.",
        "Tap \"Confirm\" to execute the selected unbind option.",
        "Wait for the lock to complete the reset process—indicator lights will confirm successful completion."
      ],
      "expected_result": "The lock is fully disconnected from the Tuya app, and if \"Unbind and wipe data\" was selected, all user data is erased and the lock returns to factory-default state ready for new ownership or reconfiguration.",
      "common_mistakes": [
        "Selecting \"Unbind\" instead of \"Unbind and wipe data\" when transferring ownership - leaves all previous user data intact on the lock",
        "Attempting to re-pair lock immediately after unbind without waiting for reset completion - causes pairing failures",
        "Not informing all household members before unbinding - sudden loss of access causes confusion and inconvenience"
      ]
    },
    {
      "handle": "venix-create-home",
      "title": "Create a home",
      "category": "App management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Create a home in the Tuya app.",
      "images": [],
      "notes": [
        "The person creating the home becomes its Homeowner."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "On the app homepage, tap “Me”, then “Home Management”.",
        "Tap “Create a Home”.",
        "Enter the home name, optionally set the location, select or add rooms, then tap “Save”."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 39
    },
    {
      "handle": "venix-add-member",
      "title": "Add an administrator or common member",
      "category": "App management",
      "estimated_time": "3 minutes",
      "difficulty": "Easy",
      "summary": "Add an administrator or common member in the Tuya app.",
      "images": [],
      "notes": [
        "The member must register a Tuya account before being added."
      ],
      "warnings": [],
      "tips": [],
      "steps": [
        "Open “Home Management” and select the home.",
        "Tap “Add Member”.",
        "Under “Family Role”, choose Administrator or Common Member.",
        "Enter the required name, region and account details, then tap “Save”."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 40
    },
    {
      "handle": "venix-transfer-home",
      "title": "Transfer homeownership",
      "category": "App management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Transfer homeownership in the Tuya app.",
      "images": [],
      "notes": [],
      "warnings": [
        "Make sure the new owner already has administrator rights on the lock. You will no longer be Homeowner after transfer."
      ],
      "tips": [],
      "steps": [
        "Open “Home Management” and select the home.",
        "Tap “Manage Permissions”, then “Transfer Home Ownership”.",
        "Select the new Homeowner and tap “Confirm”."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 42
    },
    {
      "handle": "venix-remove-member",
      "title": "Remove a member",
      "category": "App management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Remove a member in the Tuya app.",
      "images": [],
      "notes": [],
      "warnings": [
        "Removing a member does not delete their unlocking credentials. Delete those separately before removing the member."
      ],
      "tips": [],
      "steps": [
        "Delete the member’s password, face and palmprint credentials if their access should be revoked.",
        "Open “Home Management” and select the home.",
        "Select the member, tap “Remove Member” and confirm."
      ],
      "expected_result": "",
      "common_mistakes": [],
      "source_pdf_page": 44
    }
  ],
  "troubleshooting": [
    {
      "handle": "venix-wont-connect",
      "title": "Lock won't connect to Wi-Fi or add to the app",
      "category": "App setup",
      "priority": "high",
      "explanation": "Venix only joins 2.4 GHz networks and only while it is in pairing mode (slow blink after pressing 3 and the unlock key together). If the lock was bound before, it must be unbound in the app first. A mistyped password fails silently.",
      "symptoms": [
        "\"Venix\" never appears in Add Device.",
        "The app hangs on the connection step and times out.",
        "The indicator never blinks slowly."
      ],
      "quick_checks": [
        "You pressed 3 and the unlock key at the same time and heard the voice prompt.",
        "The indicator is blinking slowly while you add the device.",
        "The network you picked is 2.4 GHz, and the password is typed correctly.",
        "You are within about 5 metres of the router.",
        "The lock is not still bound to a previous account."
      ],
      "likely_causes": [
        "5 GHz network chosen, or merged bands handing the phone 5 GHz.",
        "Pairing mode not active.",
        "Wrong password.",
        "Lock previously bound and never unbound."
      ],
      "fix_steps": [
        "Move near the router and put your phone on the 2.4 GHz network.",
        "Press 3 and the unlock key together, wait for the prompt and the slow blink.",
        "In Tuya Smart tap Add Device, choose Venix, select the 2.4 GHz network, enter the password and tap Next.",
        "If the lock was bound before, tap the pencil icon on the lock page, Remove Device, then Unbind, and try again.",
        "If nothing changes, factory reset the lock and repeat."
      ],
      "related_guides": [
        "venix-09",
        "venix-10",
        "venix-18",
        "venix-03"
      ],
      "support_evidence": [
        "A short video of the indicator after pressing 3 and unlock",
        "A screenshot of the step where the app fails",
        "Router make/model and whether it has a separate 2.4 GHz network"
      ],
      "app_links": true
    },
    {
      "handle": "venix-face-not-recognised",
      "title": "Face recognition does not unlock",
      "category": "Access methods",
      "priority": "high",
      "explanation": "The face template is only as good as its enrolment. The source manual specifies 30–80 cm from the camera in normal indoor lighting, facing the camera directly. Enrolling with glasses, hats or masks you do not wear every day, or in strong backlight, produces a template that fails at the door.",
      "symptoms": [
        "The lock does not react to your face.",
        "It recognises you sometimes, usually in daylight.",
        "It works for one person but not another."
      ],
      "quick_checks": [
        "The face credential is saved under the right member in Member Management.",
        "You stand 30–80 cm away, facing the camera directly.",
        "The camera lens is clean.",
        "You are not strongly backlit by the sun or a bright light behind you."
      ],
      "likely_causes": [
        "Enrolled too close, too far or at an angle.",
        "Enrolled with accessories not worn daily, or in poor lighting.",
        "Dirty camera lens."
      ],
      "fix_steps": [
        "Clean the camera window with a soft cloth.",
        "In the app open the member, delete the face credential and confirm.",
        "Tap + Add beside Face recognition, tap Start to add, stand 30–80 cm away in normal indoor light, face the camera directly and follow the prompts.",
        "Test several times at the door with the door open before relying on it."
      ],
      "related_guides": [
        "venix-12",
        "venix-member-management"
      ],
      "support_evidence": [
        "Where the lock faces (indoors, porch, direct sun)",
        "A short video of an unlock attempt"
      ],
      "app_links": false
    },
    {
      "handle": "venix-palm-not-recognised",
      "title": "Palm recognition does not unlock",
      "category": "Access methods",
      "priority": "medium",
      "explanation": "Palm enrolment captures the same palm several times until it finishes. Switching hands, moving too fast, or enrolling with wet or dirty hands leaves an incomplete template that the lock rejects.",
      "symptoms": [
        "The palm reader does not respond or rejects your hand.",
        "It works only after several tries."
      ],
      "quick_checks": [
        "You are using the same palm you enrolled.",
        "Your hand is clean and dry.",
        "You hold the palm steady over the sensor rather than sweeping it past."
      ],
      "likely_causes": [
        "Different palm from the one enrolled.",
        "Wet, dirty or moving hand.",
        "Incomplete enrolment."
      ],
      "fix_steps": [
        "Wash and dry your hands.",
        "In the app open the member, tap Delete palmprint and confirm.",
        "Tap + Add beside Palmprint, tap Start to add, and place the same palm on the sensor repeatedly until enrolment finishes, then tap Done.",
        "Test at the door with the door open."
      ],
      "related_guides": [
        "venix-13"
      ],
      "support_evidence": [
        "A short video of an unlock attempt"
      ],
      "app_links": false
    },
    {
      "handle": "venix-wrong-direction",
      "title": "Motor turns the wrong way or the bolt will not throw",
      "category": "Commissioning",
      "priority": "high",
      "explanation": "Venix detects the unlocking direction automatically when the battery is first connected — but only while the lock is in its factory state with no users enrolled. If users were added first, the direction is locked in and can only be changed by a factory reset, which erases all users.",
      "symptoms": [
        "Unlock extends the bolt and lock retracts it.",
        "The motor runs but the bolt does not move fully.",
        "No long beep after the battery was connected."
      ],
      "quick_checks": [
        "The bolt moves freely by hand with the panels off.",
        "The tail bar was fitted vertically with the bolt retracted.",
        "The lock was in factory state when the battery was first connected."
      ],
      "likely_causes": [
        "Direction set after users were enrolled.",
        "Battery connected before the reset was completed.",
        "Tail bar fitted in the wrong orientation, or bolt and strike misaligned."
      ],
      "fix_steps": [
        "With the door open, remove the battery cover, hold Reset for 5 seconds until six beeps, then press the Unlock key on the outside panel and wait for \"Initialization Successful\".",
        "Disconnect and reconnect the battery; wait for the motor to rotate and the long beep.",
        "If the bolt still binds, check the tail bar orientation and the strike plate alignment before re-enrolling users."
      ],
      "related_guides": [
        "venix-03",
        "venix-04",
        "venix-07",
        "venix-05"
      ],
      "support_evidence": [
        "A short video of the bolt while you unlock and lock",
        "Door thickness and whether the door was pre-drilled"
      ],
      "app_links": false
    },
    {
      "handle": "venix-reset-fails",
      "title": "Factory reset does not complete",
      "category": "Reset",
      "priority": "medium",
      "explanation": "The reset is a two-part sequence: hold Reset for 5 seconds until six intermittent beeps, then confirm by pressing the Unlock key on the outside panel after the voice prompt. Releasing early, or skipping the confirmation, leaves the lock unchanged.",
      "symptoms": [
        "No \"Initialization Successful\" prompt.",
        "Users are still present after the reset."
      ],
      "quick_checks": [
        "You held Reset for the full 5 seconds and heard six beeps.",
        "You pressed the Unlock key on the outside panel after the voice prompt.",
        "The battery is not flat."
      ],
      "likely_causes": [
        "Reset key released too early.",
        "Confirmation step skipped.",
        "Low battery."
      ],
      "fix_steps": [
        "Remove the battery cover on the inside panel to expose the Reset key.",
        "Press and hold Reset for exactly 5 seconds until you hear six beeps.",
        "Wait for the voice prompt, then press the Unlock key on the outside panel.",
        "Listen for \"Initialization Successful\". If you do not hear it, charge or replace the battery and repeat."
      ],
      "related_guides": [
        "venix-03"
      ],
      "support_evidence": [
        "A short video of the reset attempt with sound"
      ],
      "app_links": false
    },
    {
      "handle": "venix-panels-power",
      "title": "No power, or the outside panel does not respond",
      "category": "Installation",
      "priority": "high",
      "explanation": "The outside panel is powered through the connection cable from the inside panel. A connector that is not fully seated, a cable routed over the locator or pinched behind the panel, or a battery fitted with the wrong polarity all leave the outside panel dead.",
      "symptoms": [
        "The keypad and camera stay dark.",
        "The inside panel works but the outside does not.",
        "Intermittent operation when the door is moved."
      ],
      "quick_checks": [
        "The connector is pushed fully into the socket on the inside panel.",
        "The cable runs under the locator, not over it.",
        "The cable is not pinched between the panel and the door.",
        "The battery is inserted with the correct polarity and is charged."
      ],
      "likely_causes": [
        "Connector not seated.",
        "Cable crushed under the locator or panel.",
        "Battery polarity or charge."
      ],
      "fix_steps": [
        "With the door open, remove the inside panel and reseat the connector until it clicks.",
        "Check the cable path under the locator and free any pinched section.",
        "Check the battery orientation and charge; refit the cover.",
        "If the cable is damaged, stop and contact Blusafe Australia — do not use the lock on a closed door."
      ],
      "related_guides": [
        "venix-06",
        "venix-07",
        "venix-08"
      ],
      "support_evidence": [
        "A photo of the connector and cable path with the inside panel off",
        "Door thickness"
      ],
      "app_links": false
    },
    {
      "handle": "venix-auto-lock",
      "title": "Automatic locking does not lock the door",
      "category": "Settings",
      "priority": "medium",
      "explanation": "The auto-lock timer runs after each unlock — it does not detect that the door has closed. If the door is still open, or the bolt cannot enter the strike plate because of misalignment, the bolt throws into thin air or stalls.",
      "symptoms": [
        "The door stays unlocked after the delay.",
        "The bolt extends but the door is not secure.",
        "The motor stalls or beeps."
      ],
      "quick_checks": [
        "The Automatic lock switch is on and a delay time is chosen.",
        "The door is fully closed before the delay expires.",
        "With the door closed, the bolt enters the strike plate hole without rubbing."
      ],
      "likely_causes": [
        "Auto lock switched off.",
        "Delay too short for the door to close.",
        "Strike plate misaligned or recess too shallow."
      ],
      "fix_steps": [
        "In the app tap Set, turn on Automatic lock switch, tap Auto lock delay time set and pick a delay long enough to close the door.",
        "Test with the door open first: unlock and confirm the bolt re-engages after the delay.",
        "Close the door and check the bolt enters the strike plate freely — adjust the strike plate if it rubs."
      ],
      "related_guides": [
        "venix-17",
        "venix-05"
      ],
      "support_evidence": [
        "A short video of the bolt after an unlock with the door closed",
        "A photo of the strike plate with the door open"
      ],
      "app_links": false
    },
    {
      "handle": "venix-remote-unlock",
      "title": "Remote unlock or doorbell notification does not work",
      "category": "Everyday use",
      "priority": "medium",
      "explanation": "Both features need the lock online over Wi-Fi. Remote unlock is also switched off by the \"Not available to all users\" permission setting and paused during the Dormant switch period. Holding the unlock icon too briefly cancels the command.",
      "symptoms": [
        "No notification when the doorbell key is pressed.",
        "Remote unlock times out.",
        "It works during the day but not at night."
      ],
      "quick_checks": [
        "The lock shows online in the app.",
        "Permission Settings is not set to \"Not available to all users\".",
        "The Dormant switch is off, or you are outside its sleep period.",
        "You press and hold the unlock icon until it confirms."
      ],
      "likely_causes": [
        "Lock offline.",
        "Permission restriction.",
        "Dormant period active.",
        "Unlock icon released too early."
      ],
      "fix_steps": [
        "Check the lock is online; if not, follow the Wi-Fi troubleshooting entry.",
        "In the app tap Set, then Permission Settings, and choose Only administrators or Can be used by all users.",
        "Review the Dormant switch times and switch it off if you need overnight remote access.",
        "On the lock homepage press and hold the unlock icon until the door opens."
      ],
      "related_guides": [
        "venix-15",
        "venix-16",
        "venix-10"
      ],
      "support_evidence": [
        "A screenshot of the lock page showing online status",
        "A screenshot of Permission Settings and the Dormant switch"
      ],
      "app_links": false
    },
    {
      "handle": "venix-passcode",
      "title": "A passcode does not work or cannot be deleted",
      "category": "Access methods",
      "priority": "medium",
      "explanation": "Member passwords must be 6 to 10 digits and should be tested at the lock after saving. Temporary passcodes behave differently by type: single-time and dynamic codes expire on their own and cannot be deleted manually, and a time-limited code needs its clear code from the app entered on the lock before it can be removed.",
      "symptoms": [
        "A new password is rejected at the keypad.",
        "Delete fails for a temporary passcode.",
        "A guest code still works after you removed it."
      ],
      "quick_checks": [
        "The password is 6–10 digits and saved under the right member.",
        "You tested it at the lock, not only in the app.",
        "For temporary codes, you know which type it is (Custom, Limited time, Single time, Dynamic, Empty)."
      ],
      "likely_causes": [
        "Password outside 6–10 digits or not synced.",
        "Trying to delete a single-time or dynamic code.",
        "Clear code not entered on the lock for a time-limited code."
      ],
      "fix_steps": [
        "For a member password: open Member Management, delete the password, add it again with 6–10 digits, save and test at the keypad.",
        "For a time-limited temporary code: open Temporary Passcode, tap Record, select the code, get the clear code from the app and enter it on the lock, then delete.",
        "Single-time and dynamic codes expire automatically — no action needed."
      ],
      "related_guides": [
        "venix-11",
        "venix-14"
      ],
      "support_evidence": [
        "A screenshot of the passcode record in the app"
      ],
      "app_links": false
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Lock won't connect to Wi-Fi",
      "subject": "Venix - will not connect to Wi-Fi / add to Tuya Smart",
      "body": "Hi Blusafe team,\n\nMy Venix will not connect to Wi-Fi. Here are my details:\n\nOrder number: \nApp used (Tuya Smart / Smart Life): \nDoes the indicator blink slowly after pressing 3 and unlock together? (yes/no): \nRouter make/model and whether it has a separate 2.4 GHz network: \nHas the lock been bound to another account before? (yes/no): \n\nI have attached:\n- A short video of the indicator after pressing 3 and unlock\n- A screenshot of the step where the app fails\n\nThanks,\n[Your name]"
    },
    {
      "title": "Face or palm not recognised",
      "subject": "Venix - face / palm recognition not working",
      "body": "Hi Blusafe team,\n\nMy Venix is not recognising my face or palm. Here are my details:\n\nOrder number: \nWhich method fails (face / palm): \nDistance and lighting when it fails: \nWas the credential re-enrolled following the manual? (yes/no): \nWhere the lock faces (indoors, porch, direct sun): \n\nI have attached:\n- A short video of an unlock attempt\n\nThanks,\n[Your name]"
    },
    {
      "title": "Installation or bolt problem",
      "subject": "Venix - installation / bolt problem",
      "body": "Hi Blusafe team,\n\nI have an installation problem with my Venix. Here are my details:\n\nOrder number: \nDoor thickness (mm): \nWas the door pre-drilled? (yes/no): \nWhat happens when you unlock and lock with the door open: \nDid you hear the long beep after connecting the battery? (yes/no): \n\nI have attached:\n- A short video of the bolt while unlocking and locking\n- A photo of the strike plate and a photo of the cable path with the inside panel off\n\nThanks,\n[Your name]"
    }
  ],
  "support_evidence_default": [
    "Order number and which app you used (Tuya Smart / Smart Life)",
    "Door thickness and whether the door was pre-drilled",
    "Your router's Wi-Fi band (2.4 GHz or 5 GHz)",
    "A short video of the lock's lights and any voice prompts",
    "A screenshot of the lock page in the app"
  ],
  "search_index": [
    {
      "title": "Venix Installation, Setup and Troubleshooting Manual",
      "type": "manual",
      "category": "Overview",
      "anchor": "osp-top",
      "summary": "Fit the bolt, panels and battery, set the unlocking direction, connect your Venix to 2.4 GHz Wi-Fi in the Tuya Smart app, add faces, palms and passcodes, manage members and fix the most common installation and recognition problems — without opening the PDF.",
      "keywords": "venix palm vein palmprint face recognition smart lock deadbolt tuya smart life wi-fi 2.4 ghz install bolt strike plate locator direction factory reset passcode temporary passcode doorbell remote unlock dormant auto lock member"
    },
    {
      "title": "What’s included",
      "type": "guide",
      "category": "Preparation",
      "anchor": "venix-01",
      "summary": "Verify that all components are present in the VENIX smart lock package before beginning installation.",
      "keywords": "Open the product packaging carefully and remove all contents. Lay out all items on a clean, flat surface for easy identification. Check each item against the list below to confirm nothing is missing. If any item is missing or damaged, contact your local installer or dealer before proceeding. Keep the packaging materials until installation is complete in case you need to return any items. Use the 38 mm locator only for a 38 mm door hole; a 54 mm locator is fitted as standard. Do not proceed with installation if any components are missing. Contact your local installer or dealer immediately to obtain replacement parts. Not checking for physical damage on components - Damaged parts may cause installation failure or security issues later. Losing the keys before testing mechanical operation - Keys serve as backup access; test them before enrolling digital credentials."
    },
    {
      "title": "Product dimensions and overview",
      "type": "guide",
      "category": "Preparation",
      "anchor": "venix-02",
      "summary": "Familiarise yourself with the VENIX smart lock dimensions and component layout before installation.",
      "keywords": "Review the dimension diagrams for the External Panel Unit to understand its size and mounting requirements. Review the dimension diagrams for the Internal Panel Unit to understand its size and battery compartment location. Identify all key components on both panels, including keypad area, sensor locations, and connection points. Measure your door thickness to confirm it falls within the compatible range of 35–55 mm. Refer to the product diagrams for exact millimetre measurements of both the external and internal panel units. Incorrect understanding of panel dimensions may lead to improper door preparation or misalignment during installation. Skipping dimension review before drilling - Leads to incorrectly sized holes that cannot accommodate the lock assembly. Confusing external and internal panel orientations - Results in reversed installation requiring complete disassembly. Not verifying door thickness compatibility - Doors outside the 35–55 mm range cannot properly secure the lock. Overlooking connection cable routing paths - Causes cable pinching or damage when panels are mounted."
    },
    {
      "title": "Factory reset",
      "type": "guide",
      "category": "Reset",
      "anchor": "venix-03",
      "summary": "Restore the VENIX smart lock to factory default settings, erasing all previously stored users and credentials.",
      "keywords": "Remove the battery cover on the rear of the internal panel unit to expose the Reset key. Press and hold the Reset key for exactly 5 seconds until you hear 6 intermittent beeps. Wait for the voice prompt, then press the Unlock key on the front (external) panel to confirm the reset. Listen for the voice prompt \"Initialization Successful\" to confirm the factory reset is complete. Factory reset permanently deletes all enrolled users, passwords, face recognition data, palmprint records, and custom settings. This action cannot be undone. Ensure you have administrative access to reconfigure the lock after reset. Releasing the Reset key before hearing 6 beeps - The reset process aborts and no changes are made to the lock. Forgetting to press the Unlock key after the voice prompt - The reset confirmation is not completed and settings remain unchanged. Attempting reset with users still enrolled without understanding data loss - All biometric and password data is permanently deleted without recovery option. Not verifying reset completion by checking for the success voice prompt - You may assume reset occurred when it actually failed, leading to configuration conflicts."
    },
    {
      "title": "Set the unlocking direction",
      "type": "guide",
      "category": "Commissioning",
      "anchor": "venix-04",
      "summary": "Configure the VENIX smart lock to detect and set the correct unlocking direction for your door orientation.",
      "keywords": "Confirm the lock is in factory default state with no users enrolled (perform factory reset if needed). Insert the battery to power on the lock. Wait for the motor to automatically rotate and detect the unlocking direction. Listen for a long beep, which confirms the direction has been set successfully. The unlocking direction can only be set when the lock is in factory default state with no users enrolled. If users are already registered, you must perform a factory reset first, which will erase all data. Plan this step before enrolling any members. Attempting to change direction after enrolling users - The lock prevents modification; you must reset and lose all user data to reconfigure. Not listening for the confirmation beep - You may assume direction is set when the motor failed to complete detection. Powering on the lock before ensuring factory default state - Existing user data blocks direction configuration. Ignoring door handing during initial installation planning - Results in having to reset and re-enrol all users later."
    },
    {
      "title": "Install the bolt and strike plate",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-05",
      "summary": "Install the deadbolt and strike plate assembly into your door, including drilling new holes if your door is not pre-drilled.",
      "keywords": "Verify your door thickness is between 35 mm and 55 mm using the template guide. Mark the hole centreline at 970 mm (38 3/16\") from the floor base using the provided template. Drill a 54 mm (2 1/8\") diameter hole through the door for the lockset. Fold the template along the door edge and mark a 25 mm (1\") diameter hole location for the bolt on the door edge. Drill the bolt hole and chisel a rectangular recess measuring 58 mm x 26 mm (2¼\" x 1\") with a depth of 3 mm (1/8\"). Adjust the bolt length according to your door's backset measurement. Align the bolt hole with the drive bar centre and secure the bolt plate with screws. Extend the bolt fully, close the door gently against the door jamb, and mark the strike plate locations. Mark the centre line on the door jamb, place the strike plate, and scribe the outline. Chisel the strike plate recess to a depth of 2 mm (1/8\") and drill the bolt hole to a depth of 25 mm (1\"). Insert the strike box and strike plate into the jamb recess and secure with screws. Use the supplied drilling template. The dimensions here are not a scale drawing; 970 mm is a suggested height, not a fixed installation requirement. Drilling errors can permanently damage your door. Measure twice before drilling. Wear safety goggles and ensure the door is securely supported during drilling. If your door already has pre-drilled holes matching VENIX specifications, skip section 5.1 and proceed directly to bolt installation. Drilling without confirming door is not pre-drilled - Damages existing hardware and creates oversized, unusable holes. Incorrect centreline height measurement - Causes misalignment between bolt and strike plate, preventing proper locking. Drilling the lockset hole at wrong diameter (not 54 mm/2⅛\") - Panel units will not fit through the door opening. Not chiseling deep enough for bolt plate (minimum 3 mm/1/8\") - Bolt plate protrudes and prevents panel from sitting flush against door. Forgetting to extend bolt before marking strike plate position - Strike plate hole will not align with extended bolt, preventing door from latching."
    },
    {
      "title": "Replace the locator",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-06",
      "summary": "Replace the pre-fitted 54 mm locator on the external panel with a 38 mm locator if your door hole requires it.",
      "keywords": "Loosen the two fixing screws on the external panel's locator. Remove the original 54 mm locator carefully, keeping the screws for reuse. Route the connection cable underneath the new 38 mm locator position. Fit the 38 mm locator into place and tighten securely with the two screws. The external panel ships with a 54 mm locator already installed. Only perform this replacement if your door hole diameter is 38 mm. Always route the connection cable underneath the locator, never over it, to prevent cable damage. Routing the cable over the locator instead of underneath can pinch or crush the cable when the locator is tightened, causing permanent connection failure. Routing cable over the locator instead of underneath - Cable gets crushed when screws are tightened, breaking the electrical connection. Forgetting to check door hole size before replacing - Unnecessary replacement wastes time; keep the 54 mm locator if your door hole matches. Losing the original screws during removal - Replacement screws may not match thread specifications."
    },
    {
      "title": "Install the external panel",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-07",
      "summary": "Mount the external panel unit to the door and connect it to the internal mounting plate.",
      "keywords": "Pass the external handle connection cable through the door hole from the outside to the inside. Align the spindle of the external handle with the mortise mechanism inside the door. Place the external panel unit flush against the door surface. From inside the door, push the connector cable through the mounting plate opening. Fit the mounting plate onto the spindle, ensuring proper alignment. Select M4×30 mm screws for doors 35–45 mm thick, or M4×40 mm screws for doors over 45 mm up to 55 mm thick. Use two Screws D to temporarily fix the mounting plate in place. Select the correct screw length based on your door thickness: use M4x30 mm screws for doors 35-45 mm thick, and M4x40 mm screws for doors thicker than 45 mm up to 55 mm. Install the tail bar vertically when the deadbolt is in the retracted position. Using incorrect screw lengths can damage the door or fail to secure the panel properly. Ensure the connection cable is not pinched between the panel and door surface during installation. Using wrong screw length for door thickness - M4x30 mm screws are too short for thick doors (>45 mm); M4x40 mm screws may protrude on thin doors (<35 mm). Pinching connection cable between panel and door - Causes intermittent connection failures or permanent cable damage. Installing tail bar horizontally instead of vertically - Prevents proper engagement with internal panel mechanism."
    },
    {
      "title": "Install the internal panel and battery",
      "type": "guide",
      "category": "Installation",
      "anchor": "venix-08",
      "summary": "Install the internal panel unit, connect it to the external panel, and insert the battery to power the VENIX smart lock.",
      "keywords": "Plug the external handle connector cable into the matching socket on the internal panel unit. Insert the tail bar into the inner panel knob mechanism. Attach the internal panel unit to the door, aligning it with the mounting plate and spindle. Tighten the internal panel screws using M5x10 mm-B screws and M3x4 mm-C screws securely. Open the battery compartment cover on the rear of the internal panel. Insert the lithium battery into the compartment, ensuring correct polarity alignment. Close the battery cover securely. Keep the door open after installation for commissioning and initial parameter settings. Do not close the door until you have verified all functions work correctly. Ensure the lithium battery is inserted with correct polarity. Incorrect battery orientation can damage the lock's electronic components. Keep the door open during initial setup to avoid being locked out if configuration issues occur. Not fully seating the connector cable plug - Causes intermittent connectivity between external and internal panels. Forgetting to insert tail bar into inner panel knob - Handle will not transmit motion to the locking mechanism. Closing the door immediately after installation - Prevents testing and commissioning; you may be locked out if setup fails. Not tightening all screws evenly - Panel may sit at an angle, causing misalignment and operational issues."
    },
    {
      "title": "Set up the app",
      "type": "guide",
      "category": "App setup",
      "anchor": "venix-09",
      "summary": "Download and set up the Tuya app to control and manage your VENIX smart lock remotely.",
      "keywords": "Open the App Store (iOS) or Google Play Store (Android) on your smartphone. Search for \"Tuya\" in the store. Download and install the official Tuya app. Open the Tuya app and sign up for a new account, or log in if you already have one. Follow the in-app prompts to add your VENIX smart lock to your device list. The Tuya app is required for all smart features including remote unlocking, user management, and network configuration. Ensure your smartphone has internet access during setup. Downloading unofficial or third-party apps - Only the official Tuya app supports VENIX lock integration; fake apps may compromise security. Skipping account registration - You cannot add devices or manage users without a registered Tuya account. Using an outdated app version - Older versions may lack compatibility with current VENIX firmware features."
    },
    {
      "title": "Connect to Wi-Fi",
      "type": "guide",
      "category": "App setup",
      "anchor": "venix-10",
      "summary": "Connect your VENIX smart lock to your home Wi-Fi network through the Tuya app for remote access and control.",
      "keywords": "On the front (external) panel of the lock, press the \"3\" key and the \"🔓\" key simultaneously. Wait for the voice prompt and observe the indicator light blinking slowly, confirming pairing mode is active. Open the Tuya app on your smartphone and tap \"Add Device\". Select \"Venix\" from the device list. Select your 2.4 GHz Wi-Fi network from the available networks list. Enter your Wi-Fi password accurately and tap \"Next\". Wait for the app to complete the connection process with the door lock. When the app displays \"Device Added Successfully\", tap \"Done\" to finish setup. The VENIX lock only supports 2.4 GHz Wi-Fi networks. It will not connect to 5 GHz networks. Ensure your router broadcasts a 2.4 GHz signal and that you have the correct password ready. If re-networking is needed after initial binding, you must unbind the device in the app, clear data, or restore factory defaults first. Attempting to connect to a 5 GHz Wi-Fi network - The lock hardware only supports 2.4 GHz; connection will fail indefinitely. Not pressing both keys (3 + 🔓) simultaneously - Pairing mode will not activate and the indicator will not blink. Entering incorrect Wi-Fi password - Connection fails silently; double-check password before submitting. Standing too far from the router during setup - Weak signal causes timeout; stay within 5 metres (16 feet) of the router."
    },
    {
      "title": "Member management",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-member-management",
      "summary": "Member management in the Tuya app.",
      "keywords": "On the lock homepage, tap “Member Management”. Select a member to manage their password, face and palmprint credentials. To revoke access, delete the member’s credentials before removing the member."
    },
    {
      "title": "Add or remove passwords",
      "type": "guide",
      "category": "Access methods",
      "anchor": "venix-11",
      "summary": "Add or remove numeric passwords for individual members through the Tuya app's Member Management interface.",
      "keywords": "Open the Tuya app and navigate to your VENIX lock's homepage. Tap \"Member Management\" at the bottom of the screen. Select the designated member for whom you want to add or remove a password. To Add a Password: Tap \"+ Add\" beside the \"Password\" section. To Add a Password: Enter a numeric password between 6 and 10 digits in length. To Add a Password: Tap \"Save\" to confirm and store the password. To Remove a Password: Tap \"Delete Password\" in the member's credential list. To Remove a Password: Tap \"Confirm\" when prompted to permanently delete the password. Turn on the \"Special Password\" toggle when creating a password if you want the lock to send a hijack alert notification. Special passwords allow covert emergency alerts while still unlocking the door. Passwords are visible to anyone who observes entry. Choose passwords that are not easily guessable (avoid birthdays, sequential numbers like 123456, or repeated digits like 111111). Never share passwords via unsecured channels such as text messages or email. Not enabling \"Special Password\" for emergency contacts - Regular passwords do not trigger hijack alerts; enable this feature for trusted individuals who may need to signal distress. Deleting a password without confirming - Accidental deletion locks out the member; verify before confirming removal. Not testing newly added password on the physical lock - App confirmation does not guarantee hardware synchronization; always test entry."
    },
    {
      "title": "Add or remove face recognition",
      "type": "guide",
      "category": "Access methods",
      "anchor": "venix-12",
      "summary": "Add or remove face recognition credentials for individual members through the Tuya app's Member Management interface.",
      "keywords": "Open the Tuya app and navigate to your VENIX lock's homepage. Tap \"Member Management\" at the bottom of the screen. Select the designated member for whom you want to add or remove face recognition. To Add Face Recognition: Tap \"+ Add\" beside the \"Face recognition\" section. To Add Face Recognition: Tap \"Start to add\" to begin the enrolment process. To Add Face Recognition: Position yourself 30–80 cm from the lock's face camera in normal indoor lighting. To Add Face Recognition: Face the camera directly and follow the on-screen prompts to complete face enrolment. To Add Face Recognition: Tap \"Done\" when enrolment is successfully completed. To Remove Face Recognition: Tap \"Delete Face recognition\" in the member's credential list. To Remove Face Recognition: Tap \"Confirm\" when prompted to permanently delete the face data. Face the camera directly and follow the on-screen prompts. The supplied PDF specifies 30–80 cm in normal indoor lighting. Remove a person’s face credential when they should no longer have access. Enrolling face in poor lighting conditions - Low light or harsh shadows reduce recognition accuracy; use normal indoor lighting. Not facing the camera directly during enrolment - Angled faces create incomplete templates that fail during actual use. Wearing accessories during enrolment that are not worn daily (sunglasses, hats, masks) - Recognition fails when accessories are removed; enrol with typical daily appearance."
    },
    {
      "title": "Add or remove palmprints",
      "type": "guide",
      "category": "Access methods",
      "anchor": "venix-13",
      "summary": "Learn how to enrol and remove palmprint biometric data for authorised members on your VENIX smart lock.",
      "keywords": "Enter the lock interface and tap \"Member Management\". Select the designated member from the member list. Tap \"+ Add\" beside the \"Palmprint\" option. Tap \"Start to add\" to begin the enrolment process. Place the same palm on the lock's palm-recognition area repeatedly until enrolment finishes, then tap \"Done\". To remove a palmprint, return to \"Member Management\", select the member, tap \"Delete palmprint\", and confirm deletion. Palm recognition requires placing the same palm repeatedly on the sensor area until enrolment completes successfully. Ensure hands are clean and dry before enrolling palmprints. Moisture or dirt may reduce recognition accuracy. Using different palms during enrolment - causes failed recognition and requires re-enrolment Placing palm too quickly - results in incomplete biometric data capture Enrolling with wet or dirty hands - reduces recognition accuracy and may cause false rejections"
    },
    {
      "title": "Manage temporary passcodes",
      "type": "guide",
      "category": "Access methods",
      "anchor": "venix-14",
      "summary": "Create and manage temporary passcodes with various validity options for guests or short-term access on your VENIX smart lock.",
      "keywords": "Enter the lock interface and tap \"Temporary Passcode\". Choose the password type: Custom, Limited time, Single time, Dynamic, or Empty. Enter a password name (optional), set the effective start time and invalid end time, then tap \"Get password\". To remove a temporary passcode, enter the Temporary Passcode interface, tap \"Record\", select the password to remove, and tap Delete. Temporary passcodes include Custom, Limited time, Single time, Dynamic, and Empty password types to suit different access scenarios. Time-limited passwords require obtaining a clear code from the app and entering it on the lock before deletion. One-time and dynamic passwords cannot be manually deleted—they expire automatically. Attempting to delete one-time or dynamic passwords manually - these expire automatically and cannot be deleted Forgetting to obtain clear code from app before deleting time-limited passwords - deletion will fail without this step Not naming passwords clearly - makes it difficult to identify which code belongs to which guest"
    },
    {
      "title": "Doorbell and remote unlocking",
      "type": "guide",
      "category": "Everyday use",
      "anchor": "venix-15",
      "summary": "Enable doorbell-triggered remote unlocking and direct remote unlock functionality through the VENIX app with Wi-Fi connectivity.",
      "keywords": "Pair the lock with Wi-Fi through the lock interface settings. Press the doorbell key on the external panel—the paired phone receives a doorbell request notification. Tap the notification to view the scene outside the door, accept the call to talk with visitors, or tap Unlock to open the door remotely. For direct remote unlock, enter the lock homepage, press and hold the unlock icon until confirmed—the door opens immediately. Alternatively, tap \"Video surveillance\" on the lock homepage to view real-time outdoor footage and unlock remotely from the video interface. The lock must be paired with Wi-Fi before doorbell unlocking or remote unlock features can function properly. Ensure stable Wi-Fi connection to avoid failed remote unlock attempts. Test the feature after initial setup to confirm functionality. Attempting remote unlock without Wi-Fi pairing - feature will not function without network connectivity Not testing remote unlock after setup - may discover connectivity issues only when urgently needed Holding unlock icon too briefly - incomplete press fails to trigger unlock confirmation"
    },
    {
      "title": "Permissions and Dormant switch",
      "type": "guide",
      "category": "Settings",
      "anchor": "venix-16",
      "summary": "Configure user permission levels and activate the Dormant switch to restrict lock functionality during designated sleep periods.",
      "keywords": "Tap \"Set\" on the lock homepage to access settings. Tap \"Permission Settings\" and choose one of three options: Only administrators, Can be used by all users, or Not available to all users. Tap \"Confirm\" to apply the selected permission level. To enable the Dormant switch, navigate to settings and activate the Dormant switch option. Configure the sleep period start and end times according to household preferences. Permission settings control which users can access lock features, while the Dormant switch disables most functions during sleep hours For example, real-time video surveillance and remote management. “Not available to all users” disables remote unlock; it does not describe every local unlocking method. Forgetting to inform household members about Dormant switch activation - causes confusion when lock becomes unresponsive during sleep hours Configuring overly long dormant periods - may prevent legitimate late-night or early-morning access"
    },
    {
      "title": "Automatic lock and lock delay",
      "type": "guide",
      "category": "Settings",
      "anchor": "venix-17",
      "summary": "Set the automatic re-bolting delay after each unlock.",
      "keywords": "Enter the lock interface and tap \"Set\" to access settings. Turn on the \"Automatic lock switch\" to enable auto-lock functionality. Tap \"Auto lock delay time set\" and choose a delay duration (e.g., 5s, 10s, 15s, 30s). Tap \"Confirm\" to save the selected delay time. Test with the door open first: unlock and check that the bolt re-engages after the selected delay. Then check door and strike alignment before testing normal closed-door operation. The PDF states that the timer runs after each unlock. This is not confirmation that the door has closed. Ensure the door closes completely before the auto-lock delay expires. Obstructions or improperly closed doors may prevent successful automatic locking. Setting delay time too short (e.g., 5s) - may not allow sufficient time to enter and close door properly Setting delay time too long (e.g., 60s+) - increases risk of forgetting to manually lock if auto-lock fails Not adjusting delay for household habits - families with children or pets may need longer delays for safe entry"
    },
    {
      "title": "Lock navigation volume",
      "type": "guide",
      "category": "Settings",
      "anchor": "venix-volume",
      "summary": "Lock navigation volume in the Tuya app.",
      "keywords": "On the lock homepage, tap “Set”. Tap “Lock navigation volume” and choose Mute, Low, Normal or High. Tap “Confirm”."
    },
    {
      "title": "Alerts and records",
      "type": "guide",
      "category": "Everyday use",
      "anchor": "venix-records",
      "summary": "Alerts and records in the Tuya app.",
      "keywords": "Open “Album / Log”, then “Log”. Choose “Alarm messages” to review event notifications. Choose “Door opening record” to review recorded unlock events and timestamps. The PDF also describes an optional “Cloud storage service” in Set for doorbell videos and alarm snapshots. Review its terms in the app before enabling it."
    },
    {
      "title": "Unbind or remove the device",
      "type": "guide",
      "category": "Reset",
      "anchor": "venix-18",
      "summary": "Completely unbind and factory-reset your VENIX smart lock to remove all user data and disconnect it from the Tuya app for transfer or reconfiguration.",
      "keywords": "Enter the lock interface and tap the pencil icon in the top-right corner to access device management. Tap \"Remove Device\" to initiate the unbinding process. Select \"Unbind and wipe data\" to perform a complete factory reset, or choose \"Unbind\" to only disconnect from the app while preserving data. Tap \"Confirm\" to execute the selected unbind option. Wait for the lock to complete the reset process—indicator lights will confirm successful completion. Two unbind options exist—\"Unbind\" only disconnects the lock from the app while preserving all user data, whereas \"Unbind and wipe data\" performs a complete factory reset erasing all biometric data, passcodes, and member profiles. Choosing \"Unbind and wipe data\" permanently deletes all enrolled faces, palmprints, passwords, and member information. This action cannot be undone. Ensure you have backed up any critical access credentials before proceeding. Selecting \"Unbind\" instead of \"Unbind and wipe data\" when transferring ownership - leaves all previous user data intact on the lock Attempting to re-pair lock immediately after unbind without waiting for reset completion - causes pairing failures Not informing all household members before unbinding - sudden loss of access causes confusion and inconvenience"
    },
    {
      "title": "Create a home",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-create-home",
      "summary": "Create a home in the Tuya app.",
      "keywords": "On the app homepage, tap “Me”, then “Home Management”. Tap “Create a Home”. Enter the home name, optionally set the location, select or add rooms, then tap “Save”. The person creating the home becomes its Homeowner."
    },
    {
      "title": "Add an administrator or common member",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-add-member",
      "summary": "Add an administrator or common member in the Tuya app.",
      "keywords": "Open “Home Management” and select the home. Tap “Add Member”. Under “Family Role”, choose Administrator or Common Member. Enter the required name, region and account details, then tap “Save”. The member must register a Tuya account before being added."
    },
    {
      "title": "Transfer homeownership",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-transfer-home",
      "summary": "Transfer homeownership in the Tuya app.",
      "keywords": "Open “Home Management” and select the home. Tap “Manage Permissions”, then “Transfer Home Ownership”. Select the new Homeowner and tap “Confirm”. Make sure the new owner already has administrator rights on the lock. You will no longer be Homeowner after transfer."
    },
    {
      "title": "Remove a member",
      "type": "guide",
      "category": "App management",
      "anchor": "venix-remove-member",
      "summary": "Remove a member in the Tuya app.",
      "keywords": "Delete the member’s password, face and palmprint credentials if their access should be revoked. Open “Home Management” and select the home. Select the member, tap “Remove Member” and confirm. Removing a member does not delete their unlocking credentials. Delete those separately before removing the member."
    },
    {
      "title": "Lock won't connect to Wi-Fi or add to the app",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "venix-wont-connect",
      "summary": "\"Venix\" never appears in Add Device.",
      "keywords": "\"Venix\" never appears in Add Device. The app hangs on the connection step and times out. The indicator never blinks slowly. 5 GHz network chosen, or merged bands handing the phone 5 GHz. Pairing mode not active. Wrong password. Lock previously bound and never unbound. Move near the router and put your phone on the 2.4 GHz network. Press 3 and the unlock key together, wait for the prompt and the slow blink. In Tuya Smart tap Add Device, choose Venix, select the 2.4 GHz network, enter the password and tap Next. If the lock was bound before, tap the pencil icon on the lock page, Remove Device, then Unbind, and try again. If nothing changes, factory reset the lock and repeat. Venix only joins 2.4 GHz networks and only while it is in pairing mode (slow blink after pressing 3 and the unlock key together). If the lock was bound before, it must be unbound in the app first. A mistyped password fails silently."
    },
    {
      "title": "Face recognition does not unlock",
      "type": "troubleshooting",
      "category": "Access methods",
      "anchor": "venix-face-not-recognised",
      "summary": "The lock does not react to your face.",
      "keywords": "The lock does not react to your face. It recognises you sometimes, usually in daylight. It works for one person but not another. Enrolled too close, too far or at an angle. Enrolled with accessories not worn daily, or in poor lighting. Dirty camera lens. Clean the camera window with a soft cloth. In the app open the member, delete the face credential and confirm. Tap + Add beside Face recognition, tap Start to add, stand 30–80 cm away in normal indoor light, face the camera directly and follow the prompts. Test several times at the door with the door open before relying on it. The face template is only as good as its enrolment. The source manual specifies 30–80 cm from the camera in normal indoor lighting, facing the camera directly. Enrolling with glasses, hats or masks you do not wear every day, or in strong backlight, produces a template that fails at the door."
    },
    {
      "title": "Palm recognition does not unlock",
      "type": "troubleshooting",
      "category": "Access methods",
      "anchor": "venix-palm-not-recognised",
      "summary": "The palm reader does not respond or rejects your hand.",
      "keywords": "The palm reader does not respond or rejects your hand. It works only after several tries. Different palm from the one enrolled. Wet, dirty or moving hand. Incomplete enrolment. Wash and dry your hands. In the app open the member, tap Delete palmprint and confirm. Tap + Add beside Palmprint, tap Start to add, and place the same palm on the sensor repeatedly until enrolment finishes, then tap Done. Test at the door with the door open. Palm enrolment captures the same palm several times until it finishes. Switching hands, moving too fast, or enrolling with wet or dirty hands leaves an incomplete template that the lock rejects."
    },
    {
      "title": "Motor turns the wrong way or the bolt will not throw",
      "type": "troubleshooting",
      "category": "Commissioning",
      "anchor": "venix-wrong-direction",
      "summary": "Unlock extends the bolt and lock retracts it.",
      "keywords": "Unlock extends the bolt and lock retracts it. The motor runs but the bolt does not move fully. No long beep after the battery was connected. Direction set after users were enrolled. Battery connected before the reset was completed. Tail bar fitted in the wrong orientation, or bolt and strike misaligned. With the door open, remove the battery cover, hold Reset for 5 seconds until six beeps, then press the Unlock key on the outside panel and wait for \"Initialization Successful\". Disconnect and reconnect the battery; wait for the motor to rotate and the long beep. If the bolt still binds, check the tail bar orientation and the strike plate alignment before re-enrolling users. Venix detects the unlocking direction automatically when the battery is first connected — but only while the lock is in its factory state with no users enrolled. If users were added first, the direction is locked in and can only be changed by a factory reset, which erases all users."
    },
    {
      "title": "Factory reset does not complete",
      "type": "troubleshooting",
      "category": "Reset",
      "anchor": "venix-reset-fails",
      "summary": "No \"Initialization Successful\" prompt.",
      "keywords": "No \"Initialization Successful\" prompt. Users are still present after the reset. Reset key released too early. Confirmation step skipped. Low battery. Remove the battery cover on the inside panel to expose the Reset key. Press and hold Reset for exactly 5 seconds until you hear six beeps. Wait for the voice prompt, then press the Unlock key on the outside panel. Listen for \"Initialization Successful\". If you do not hear it, charge or replace the battery and repeat. The reset is a two-part sequence: hold Reset for 5 seconds until six intermittent beeps, then confirm by pressing the Unlock key on the outside panel after the voice prompt. Releasing early, or skipping the confirmation, leaves the lock unchanged."
    },
    {
      "title": "No power, or the outside panel does not respond",
      "type": "troubleshooting",
      "category": "Installation",
      "anchor": "venix-panels-power",
      "summary": "The keypad and camera stay dark.",
      "keywords": "The keypad and camera stay dark. The inside panel works but the outside does not. Intermittent operation when the door is moved. Connector not seated. Cable crushed under the locator or panel. Battery polarity or charge. With the door open, remove the inside panel and reseat the connector until it clicks. Check the cable path under the locator and free any pinched section. Check the battery orientation and charge; refit the cover. If the cable is damaged, stop and contact Blusafe Australia — do not use the lock on a closed door. The outside panel is powered through the connection cable from the inside panel. A connector that is not fully seated, a cable routed over the locator or pinched behind the panel, or a battery fitted with the wrong polarity all leave the outside panel dead."
    },
    {
      "title": "Automatic locking does not lock the door",
      "type": "troubleshooting",
      "category": "Settings",
      "anchor": "venix-auto-lock",
      "summary": "The door stays unlocked after the delay.",
      "keywords": "The door stays unlocked after the delay. The bolt extends but the door is not secure. The motor stalls or beeps. Auto lock switched off. Delay too short for the door to close. Strike plate misaligned or recess too shallow. In the app tap Set, turn on Automatic lock switch, tap Auto lock delay time set and pick a delay long enough to close the door. Test with the door open first: unlock and confirm the bolt re-engages after the delay. Close the door and check the bolt enters the strike plate freely — adjust the strike plate if it rubs. The auto-lock timer runs after each unlock — it does not detect that the door has closed. If the door is still open, or the bolt cannot enter the strike plate because of misalignment, the bolt throws into thin air or stalls."
    },
    {
      "title": "Remote unlock or doorbell notification does not work",
      "type": "troubleshooting",
      "category": "Everyday use",
      "anchor": "venix-remote-unlock",
      "summary": "No notification when the doorbell key is pressed.",
      "keywords": "No notification when the doorbell key is pressed. Remote unlock times out. It works during the day but not at night. Lock offline. Permission restriction. Dormant period active. Unlock icon released too early. Check the lock is online; if not, follow the Wi-Fi troubleshooting entry. In the app tap Set, then Permission Settings, and choose Only administrators or Can be used by all users. Review the Dormant switch times and switch it off if you need overnight remote access. On the lock homepage press and hold the unlock icon until the door opens. Both features need the lock online over Wi-Fi. Remote unlock is also switched off by the \"Not available to all users\" permission setting and paused during the Dormant switch period. Holding the unlock icon too briefly cancels the command."
    },
    {
      "title": "A passcode does not work or cannot be deleted",
      "type": "troubleshooting",
      "category": "Access methods",
      "anchor": "venix-passcode",
      "summary": "A new password is rejected at the keypad.",
      "keywords": "A new password is rejected at the keypad. Delete fails for a temporary passcode. A guest code still works after you removed it. Password outside 6–10 digits or not synced. Trying to delete a single-time or dynamic code. Clear code not entered on the lock for a time-limited code. For a member password: open Member Management, delete the password, add it again with 6–10 digits, save and test at the keypad. For a time-limited temporary code: open Temporary Passcode, tap Record, select the code, get the clear code from the app and enter it on the lock, then delete. Single-time and dynamic codes expire automatically — no action needed. Member passwords must be 6 to 10 digits and should be tested at the lock after saving. Temporary passcodes behave differently by type: single-time and dynamic codes expire on their own and cannot be deleted manually, and a time-limited code needs its clear code from the app entered on the lock before it can be removed."
    }
  ],
  "support_email": ""
};
